import { render, staticRenderFns } from "./globalcontact.vue?vue&type=template&id=718dbdf8"
import script from "./globalcontact.vue?vue&type=script&lang=js"
export * from "./globalcontact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Svanehoj-v-13.Website\\src\\Webpack\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718dbdf8')) {
      api.createRecord('718dbdf8', component.options)
    } else {
      api.reload('718dbdf8', component.options)
    }
    module.hot.accept("./globalcontact.vue?vue&type=template&id=718dbdf8", function () {
      api.rerender('718dbdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/vue/globalcontact.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/globalcontact.vue
// module id = 35
// module chunks = 0